import { message } from "antd";
import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
  withCredentials: true,
});

// function generateRequestId() {
//   const timestamp = Date.now();
//   const randomPart = Math.random().toString(36).slice(2, 10);
//   return `req_${timestamp}_${randomPart}`;
// }

instance.interceptors.request.use((config) => {
  // if (!("X-REQUEST-ID" in config.headers)) {
  //   (config.headers as any)["X-REQUEST-ID"] = generateRequestId();
  // }

  if (config.method?.toLocaleUpperCase() === "GET") {
    if (!config.params) {
      config.params = {};
    }
    config.params["_"] = +new Date();
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    const { data, config } = response;
    console.log("response data:", data, "config:", config);

    return {
      ...data,
      msg: `1、code：【${data.code}】 2、msg：${data.msg} 3、requestId: ${data.requestId}`,
    };
  },
  (error) => {
    const {
      response: { data },
    } = error;

    let errMsg;
    errMsg =
      `1、code：【${data.code}】 2、msg：${data.msg} 3、requestId: ${data.requestId}` ||
      "请求失败";
    message.error(errMsg);
    return Promise.reject(errMsg);
  }
);

export const http = instance;
export default http;
